import { render, staticRenderFns } from "./TradeRecord.vue?vue&type=template&id=90953cf2&scoped=true&"
import script from "./TradeRecord.vue?vue&type=script&lang=js&"
export * from "./TradeRecord.vue?vue&type=script&lang=js&"
import style0 from "./TradeRecord.vue?vue&type=style&index=0&id=90953cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90953cf2",
  null
  
)

export default component.exports